import { render, staticRenderFns } from "./SchemeName.vue?vue&type=template&id=7505a854&"
import script from "./SchemeName.vue?vue&type=script&lang=js&"
export * from "./SchemeName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports